import api from '@pray/shared/utils/api';

export type RegeneratePrayRadioBackgroundImagesResult = {
  checked: number;
  regenerated: number;
  daily_item_ids: string[];
};

// Admin-only (PB-38064): re-runs the AI background image generation for every
// Pray Radio episode in the range whose image is missing or doesn't load,
// skipping episodes still processing. The range is capped at ~a week server-side.
export async function regeneratePrayRadioBackgroundImages({
  startDate,
  endDate,
}: {
  startDate: string;
  endDate: string;
}): Promise<RegeneratePrayRadioBackgroundImagesResult> {
  const url = '/web/studio/pray-radio/regenerate-background-images';
  const response = await api.executePostRequest(url, { start_date: startDate, end_date: endDate });

  return response.data as RegeneratePrayRadioBackgroundImagesResult;
}
